import React from "react";
import Mainpagebar from "../components/mainpagebar";

function Techstack() {
	return (
		<div className='h-[calc(100vh-30px-25px)] w-[calc(100vw-50px)] md:w-5/6 bg-[#24292e] scrollbar-hide overflow-y-auto overflow-x-auto  '>
			<Mainpagebar />
			<h1 className='m-[1.5rem] text-[#E1E4E8] text-left  text-lg md:text-2xl font-bold'>
				Technologies that i am familiar with
			</h1>
			<div className='text-left m-4 flex md:text-2xl'>
				<p className='mr-[1rem] text-gray-500 font-Inconsolata font-semibold'>
					1
				</p>
				<span className='text-[#E1E4E8] ml-4'>&#123;</span>
			</div>

			<div className='text-left m-4 flex md:text-2xl'>
				<p className='mr-[1rem] text-gray-500 font-Inconsolata font-semibold'>
					2
				</p>
				<p className='text-[#f9826c] ml-10 md:ml-20'> Programming Languages </p>
				<a className='text-[#E1E4E8] ml-5' href=''>
					&#123;{" "}
				</a>
			</div>

			<div className='text-left m-4 flex md:text-2xl'>
				<p className='mr-[1rem] text-gray-500 font-Inconsolata font-semibold'>
					3
				</p>
				<a className='text-[#f9826c] ml-10 md:ml-20' href=''>
					{" "}
				</a>
				<div className='flex'>
					<span className='text-[#E1E4E8] ml-4 flex'>
						Java{" "}
						<img
							className='ml-2'
							src='https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg'
							alt='java'
							width='30'
							height='30'
						/>
					</span>
					<span className='text-[#E1E4E8] ml-4 flex'>
						C++{" "}
						<img
							className='ml-2'
							src='https://raw.githubusercontent.com/devicons/devicon/master/icons/cplusplus/cplusplus-original.svg'
							alt='cplusplus'
							width='30'
							height='30'
						/>
					</span>
				</div>
			</div>

			<div className='text-left m-4 flex md:text-2xl'>
				<p className='mr-[1rem] text-gray-500 font-Inconsolata font-semibold'>
					4
				</p>
				<span className='text-[#E1E4E8] ml-10 md:ml-20'>&#125;</span>
			</div>

			<div className='text-left m-4 flex md:text-2xl'>
				<p className='mr-[1rem] text-gray-500 font-Inconsolata font-semibold'>
					5
				</p>
				<p className='text-[#f9826c] ml-10 md:ml-20 md:pl-1'>
					{" "}
					Frontend Tools{" "}
				</p>
				<a className='text-[#E1E4E8] ml-5' href=''>
					&#123;{" "}
				</a>
			</div>

			<div className='text-left m-4 flex md:text-2xl'>
				<p className='mr-[1rem] text-gray-500 font-Inconsolata font-semibold'>
					6
				</p>
				<a className='text-[#f9826c] ml-10 md:ml-20' href=''>
					{" "}
				</a>
				<div className='flex'>
					<span className='text-[#E1E4E8] ml-4 flex'>
						Html{" "}
						<img
							className='mx-3'
							src='https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original-wordmark.svg'
							alt='html5'
							width='30'
							height='30'
						/>
					</span>
					<span className='text-[#E1E4E8] ml-4 flex'>
						Css{" "}
						<img
							className='mx-3'
							src='https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original-wordmark.svg'
							alt='css3'
							width='30'
							height='30'
						/>
					</span>
					<span className='text-[#E1E4E8] ml-4 flex'>
						JavaScript{" "}
						<img
							className='mx-3'
							src='https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg'
							alt='javascript'
							width='30'
							height='30'
						/>
					</span>
				</div>
			</div>

			<div className='text-left m-4 flex md:text-2xl'>
				<p className='mr-[1rem] text-gray-500 font-Inconsolata font-semibold'>
					7
				</p>
				<a className='text-[#f9826c] ml-10 md:ml-20' href=''>
					{" "}
				</a>
				<div className='flex'>
					<span className='text-[#E1E4E8] ml-4 flex'>
						React{" "}
						<img
							className='mr-8 ml-3 md:mx-2'
							src='https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original-wordmark.svg'
							alt='react'
							width='30'
							height='30'
						/>
					</span>
					<span className='text-[#E1E4E8] ml-4 flex'>
						Tailwind <span className='hidden md:flex mx-2'>Css</span>
						<img
							className='mr-6 ml-3 md:mx-2'
							src='https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg'
							alt='tailwind'
							width='30'
							height='30'
						/>
					</span>
					<span className='text-[#E1E4E8] ml-4 flex'>
						Bootstrap{" "}
						<img
							className='mx-3'
							src='https://raw.githubusercontent.com/devicons/devicon/master/icons/bootstrap/bootstrap-plain-wordmark.svg'
							alt='bootstrap'
							width='30'
							height='30'
						/>
					</span>
				</div>
			</div>

			<div className='text-left m-4 flex md:text-2xl'>
				<p className='mr-[1rem] text-gray-500 font-Inconsolata font-semibold'>
					8
				</p>
				<span className='text-[#E1E4E8] ml-10 md:ml-20 pl-1'>&#125;</span>
			</div>

			<div className='text-left m-4 flex md:text-2xl'>
				<p className='mr-[1rem] text-gray-500 font-Inconsolata font-semibold'>
					9
				</p>
				<p className='text-[#f9826c] ml-10 md:ml-20 md:pl-1'>AI ML</p>
				<a className='text-[#E1E4E8] ml-5' href=''>
					&#123;{" "}
				</a>
			</div>

			<div className='text-left m-4 flex md:text-2xl'>
				<p className='mr-[1rem] text-gray-500 font-Inconsolata font-semibold'>
					10
				</p>
				<a className='text-[#f9826c] ml-10 md:ml-20' href=''>
					{" "}
				</a>
				<div className='flex'>
					<span className='text-[#E1E4E8] ml-3 flex'>
						Numpy{" "}
						<img
							className='mx-3'
							src='https://www.vectorlogo.zone/logos/numpy/numpy-icon.svg'
							alt='numpy'
							width='30'
							height='30'
						/>
					</span>
					<span className='text-[#E1E4E8] ml-3 flex'>
						Pandas{" "}
						<img
							className='mx-3'
							src='https://raw.githubusercontent.com/devicons/devicon/2ae2a900d2f041da66e950e4d48052658d850630/icons/pandas/pandas-original.svg'
							alt='pandas'
							width='30'
							height='30'
						/>
					</span>
				</div>
			</div>

			<div className='text-left m-4 flex md:text-2xl'>
				<p className='mr-[1rem] text-gray-500 font-Inconsolata font-semibold'>
					11
				</p>
				<a className='text-[#f9826c] ml-10 md:ml-20' href=''>
					{" "}
				</a>
				<div className='flex'>
					<span className='text-[#E1E4E8] ml-3 flex'>
						Scikit-learn{" "}
						<img
							className='mx-3'
							src='https://upload.wikimedia.org/wikipedia/commons/0/05/Scikit_learn_logo_small.svg'
							alt='scikit_learn'
							width='30'
							height='30'
						/>
					</span>
					<span className='text-[#E1E4E8] ml-3 flex'>
						Seaborn{" "}
						<img
							className='mx-3'
							src='https://seaborn.pydata.org/_images/logo-mark-lightbg.svg'
							alt='seaborn'
							width='30'
							height='30'
						/>
					</span>
				</div>
			</div>

			<div className='text-left m-4 flex md:text-2xl'>
				<p className='mr-[1rem] text-gray-500 font-Inconsolata font-semibold'>
					12
				</p>
				<span className='text-[#E1E4E8] ml-10 md:ml-20'>&#125;</span>
			</div>

			<div className='text-left m-4 flex md:text-2xl'>
				<p className='mr-[1rem] text-gray-500 font-Inconsolata font-semibold'>
					13
				</p>
				<p className='text-[#f9826c] ml-10 md:ml-20'>Others</p>
				<a className='text-[#E1E4E8] ml-5' href=''>
					&#123;{" "}
				</a>
			</div>

			<div className='text-left m-4 flex md:text-2xl'>
				<p className='mr-[1rem] text-gray-500 font-Inconsolata font-semibold'>
					14
				</p>
				<a className='text-[#f9826c] ml-10 md:ml-20' href=''>
					{" "}
				</a>
				<div className='flex'>
					<span className='text-[#E1E4E8] ml-4 flex'>
						Git{" "}
						<img
							className='mx-3'
							src='https://www.vectorlogo.zone/logos/git-scm/git-scm-icon.svg'
							alt='git'
							width='30'
							height='30'
						/>
					</span>
					<span className='text-[#E1E4E8] ml-4 flex'>
						Sql{" "}
						<img
							className='mx-3'
							src='https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg'
							alt='mysql'
							width='30'
							height='30'
						/>
					</span>
				</div>
			</div>

			<div className='text-left m-4 flex md:text-2xl'>
				<p className='mr-[1rem] text-gray-500 font-Inconsolata font-semibold'>
					15
				</p>
				<span className='text-[#E1E4E8] ml-10 md:ml-20'>&#125;</span>
			</div>

			<div className='text-left m-4 flex md:text-2xl'>
				<p className='mr-[1rem] text-gray-500 font-Inconsolata font-semibold'>
					16
				</p>
				<span className='text-[#E1E4E8] ml-4'>&#125;</span>
			</div>
		</div>
	);
}

export default Techstack;
